import { getLanguage } from "../Managers/dataProvider";
import { BranchReportModel } from "../Managers/dataStructures";

interface AdminDetailBranchReportProps {
  array_reports: BranchReportModel[];
}

export default function AdminDetailBranchReport(
  props: AdminDetailBranchReportProps
) {
  const isEnglish = getLanguage();
  return (
    <div className="px-2 sm:px-2 lg:px-2">
      <div className="flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr className="divide-x divide-gray-200">
                  <th
                    scope="col"
                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                  >
                    {isEnglish ? "Branch" : "Filiale"}
                  </th>

                  <th
                    scope="col"
                    className="px-4 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {isEnglish ? "Total Hours" : "Gesamtarbeitsstunden"}
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {props.array_reports.map((x) => CellReportDetail(x))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

function CellReportDetail(item: BranchReportModel) {
  return (
    <tr className="divide-x divide-gray-200" key={item.branch.branch_id}>
      <td className="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-0">
        <div>
          <div>{item.branch.name}</div>
        </div>
      </td>
      <td className="whitespace-nowrap p-4 text-sm text-gray-500 max-w-[200px] overflow-ellipsis overflow-clip">
        <div>
          <div> {item.working_hours}</div>
        </div>
      </td>
    </tr>
  );
}
